var _color1 = "#FFEDEE";
var _color2 = "#FFEDEE";

var Custom_RangeSlider = {

	init:function(){

		$(".custom-rangeSlider").each(function(){
			var customRangeSlider_Manager = new CustomRangeSlider_Manager($(this));
		});
	}
}

$(window).load(function(){
	if($(".custom-rangeSlider").length){
		Custom_RangeSlider.init();
	}
})

function CustomRangeSlider_Manager(pTarget){
	
	var _target = pTarget;
	
	var _min = parseInt(_target.find('input[type="range"]').attr("min"));
	var _max = parseInt(_target.find('input[type="range"]').attr("max"));
	
	adjust_slider(_target.find('input[type="range"]').val());

	if(_target.hasClass("text")){
		// INIT CHAMPS TEXTE AVEC VALUE DU RANGE
		var _unite = _target.data("unite");
        if(_target.find('input[type="range"]')[0].hasAttribute('list')){
            
            option = $('#'+_target.find('input[type="range"]').attr('list')).find('option').eq(_target.find('input[type="range"]').val());
            value = parseInt(option.html());
        }else{
            value = _target.find('input[type="range"]').val();
        }
		_target.find("input[type='text']").val(value + " " + _unite);
	}

	// LISTENER CHANGEMENT DU TEXTE
	_target.find('input[type="text"]').on('input', function (e) {
			// Do something
			var _unite = $(this).parent().data("unite");
			var _error = false;

			//console.log("CHANGE TEXTE : " + _min + " < " + parseInt($(this).val()) + " < " + _max);

			if(parseInt($(this).val()) < _min){
				$(this).val(_min + " " + _unite);
				_error = true;
			}
			if(parseInt($(this).val()) > _max){
				$(this).val(_max + " " + _unite);
				_error = true;
			}
			
			if(_error == true){
				console.log("ERROR ! ");
			}
			_target.find('input[type="range"]').val(parseInt($(this).val()));
			adjust_slider(_target.find('input[type="range"]').val());

	});
	// LISTENER CHANGEMENT DU SLIDER
	_target.find('input[type="range"]').on('input', function () {
		//console.log("RANGE SLIDER CHANGED ! " + _min + " < " + $(this).val() + " < " + _max);
        if($(this)[0].hasAttribute('list')){
            option = $('#'+$(this).attr('list')).find('option').eq($(this).val());
            value = parseInt(option.html());
        }else{
            value = $(this).val();
        }
		adjust_slider($(this).val());

		// AFFICHAGE VALEUR DANS CHAMPS TEXTE SI TYPE TEXTE
		if(_target.hasClass("text")){
			var _unite = $(this).parent().data("unite");
			_target.find("input[type='text']").val(value + " " + _unite);
            _target.find("input[type='text']").change();
		}
	});

	function adjust_slider(_value){
		
		//console.log("ADJUST SLIDER : " + _min +" < " + _value + " < " + _max);
		
		var _range = _max - _min;
		var _val = _value - _min;

		var _pourcent = (_val * 100) / _range;

		// AFFICHAGE PROGRESS IN BLUE
		_target.find('input[type="range"]').css({background:'linear-gradient(to right, '+_color1+' 0%, '+_color1+' ' + _pourcent + '%, '+_color2+' ' + _pourcent + '%, '+_color2+' 100%)'})
	}
}